<fieldset class="radio-group" *ngIf="returnUrl == null || returnUrl == ''">
  <legend class="sr-only">Select Platform</legend>
  <label
    for="Tradestation"
    class="l-radio"
    [ngClass]="{ checked: istradstation }"
  >
    <input
      type="radio"
      (change)="handleChange($event)"
      [checked]="istradstation"
      id="Tradestation"
      name="colors"
      value="Tradestation"
    />
    <span>Web Platform</span>
  </label>
  <label for="FnO" class="l-radio" [ngClass]="{ checked: isFnO }">
    <input
      type="radio"
      (change)="handleChange($event)"
      [checked]="isFnO"
      id="FnO"
      name="colors"
      value="FnO"
    />
    <span>FnO</span>
  </label>
  <label for="Chart" class="l-radio" [ngClass]="{ checked: isChart }">
    <input
      type="radio"
      (change)="handleChange($event)"
      [checked]="isChart"
      id="Chart"
      name="colors"
      value="Chart"
    />
    <span>Trade On Chart</span>
  </label>
</fieldset>
